module.exports = __webpack_public_path__ + "static/media/logo.1134a639.svg";